import React from 'react';
import { useGetInvoicesByReservationQuery } from '../../Invoices/Service/extendedInvoicesApi';
import { extractApiErrorMessage } from '../../../Utils/apiErrorUtils';
import {
  mapReservationInvoiceDtoToLookup,
  type ReservationInvoiceLookup,
} from './reservationInvoicesLookupMapper';

export const useReservationInvoicesLookupQuery = (
  reservationId?: number
): {
  invoices: ReservationInvoiceLookup[];
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  errorMessage?: string;
} => {
  const { data, isLoading, isError, error } = useGetInvoicesByReservationQuery(reservationId ?? 0, {
    skip: !reservationId,
  });

  const invoices = React.useMemo(
    () =>
      (data ?? [])
        .map((invoice) => mapReservationInvoiceDtoToLookup(invoice))
        .filter((item): item is ReservationInvoiceLookup => item !== undefined)
        .sort((a, b) => {
          if (a.sortOrder !== b.sortOrder) {
            return a.sortOrder - b.sortOrder;
          }

          if (a.issueDate !== b.issueDate) {
            return a.issueDate.localeCompare(b.issueDate);
          }

          return a.number.localeCompare(b.number, 'pl');
        }),
    [data]
  );

  const errorMessage = isError
    ? extractApiErrorMessage(error, 'Nie udało się pobrać powiązanych faktur.')
    : undefined;

  return { invoices, isLoading, isError, error, errorMessage };
};
